import React from 'react';
import { useAuth } from '../../App';
import AccessDeniedModal from './AccessDeniedModal';

export default function RequireRole({ roles = [], children }){
  const { user } = useAuth();
  // If user not available yet, render nothing (App already gates routes by user)
  if (!user) return null;
  // allow if no roles specified
  if (!roles || roles.length === 0) return children;
  // normalize role comparisons
  const allowed = roles.some(r => String(r).toLowerCase() === String(user.role || '').toLowerCase());
  if (allowed) return children;
  return <AccessDeniedModal show={true} />;
}
